import BN from 'bn.js';
import * as yup from 'yup';

import { VIEWS, VIEWS_STORAGE } from 'lib/constants';
import { isValidAmount } from 'utils';
import checkoutFormModel from './checkout-form-model';

const {
  formField: { amount, token, receiverId }
} = checkoutFormModel;

import FungibleTokens from 'services/fungible-tokens';
const { getParsedTokenAmount, getFormattedTokenAmount } = FungibleTokens;

const getRawAmount = (amount = '0', activeToken) => {
  return getParsedTokenAmount(
    amount.toString(),
    activeToken.onChainFTMetadata?.symbol,
    activeToken.onChainFTMetadata?.decimals
  );
};

yup.addMethod(yup.string, 'amountIsComplete', function (activeToken) {
  return this.test(function (value = ''): yup.ValidationError | boolean {
    const { path, createError } = this;

    const formattedTokenAmount = getFormattedTokenAmount(
      activeToken.balance,
      activeToken.onChainFTMetadata.symbol,
      activeToken.onChainFTMetadata.decimals
    );

    if (isValidAmount(value) && new BN(activeToken.balance).isZero()) {
      return createError({
        path,
        message: 'Balance is Zero'
      });
    }

    if (
      isValidAmount(value) &&
      new BN(getRawAmount(value, activeToken)).isZero()
    ) {
      return createError({
        path,
        message: 'Value is Zero'
      });
    }

    if (isValidAmount(value) && Number(value) > Number(formattedTokenAmount)) {
      return createError({
        path,
        message: 'Balance is Exceeded'
      });
    }

    return true;
  });
});

export const validatioSchemaStorage = {
  [VIEWS_STORAGE.ENTER_AMOUNT]: (activeToken, isSendByIdTab = false) => {
    return yup.object().shape({
      [amount.name]: yup.string().amountIsComplete(activeToken),
      ...(isSendByIdTab && { [receiverId.name]: yup.string().required().matches(/^[a-zA-Z0-9-._-]/) })
    });
  },
  [VIEWS_STORAGE.CONFIRM]: () => {},
  [VIEWS_STORAGE.SUCCESS]: () => {}
};

export default {
  [VIEWS.ENTER_AMOUNT]: (activeToken) => {
    return yup.object().shape({
      [amount.name]: yup.string().amountIsComplete(activeToken),
      [token.name]: yup.string().required()
    });
  },
  [VIEWS.ENTER_RECEIVER]: () => {
    return yup.object().shape({
      [receiverId.name]: yup
        .string()
        .required()
        .matches(/^[a-zA-Z0-9-._-]/)
    });
  },
  [VIEWS.REVIEW]: () => {},
  [VIEWS.SUCCESS]: () => {}
};
